var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderTrackingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0097 83.5834H88.9438C98.2855 83.5834 103.202 78.6667 103.202 69.3251V9.83337H14.7021V69.3251C14.7513 78.6667 19.668 83.5834 29.0097 83.5834Z",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8335 9.83337H108.167",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 108.167L59.0002 98.3334V83.5834",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6667 108.167L59 98.3334",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.875 54.0834L52.3625 41.1525C53.5916 40.12 55.2141 40.415 56.05 41.7917L61.95 51.625C62.7859 53.0017 64.4084 53.2476 65.6375 52.2642L81.125 39.3334",
    stroke: "white",
    strokeWidth: 7.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTrackingIcon);
export default __webpack_public_path__ + "static/media/order_tracking_icon.16540053369429887e435b92e344ec37.svg";
export { ForwardRef as ReactComponent };